"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _linkHelper2 = _interopRequireDefault(require("../../../shared/helpers/linkHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ImageLinks = function ImageLinksComponent(_ref) {
  var sliceData = _ref.sliceData;

  if (!sliceData[0].link_url.url) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-list__brands"
  }, sliceData.map(function (_ref2) {
    var link_image = _ref2.link_image,
        link_url = _ref2.link_url;

    var _linkHelper = (0, _linkHelper2["default"])(link_url.url, link_url.target === '_blank'),
        cleanHref = _linkHelper.cleanHref,
        openNewTab = _linkHelper.openNewTab;

    return /*#__PURE__*/_react["default"].createElement("a", {
      key: link_url.url,
      href: cleanHref,
      target: openNewTab ? '_blank' : '_self',
      className: "info-list__brand"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "info-list__brand__image",
      srcSet: link_image.url,
      src: link_image.url,
      alt: link_image.name
    }));
  }));
};

ImageLinks.propTypes = {
  sliceData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    link_image: _propTypes["default"].shape({
      url: _propTypes["default"].string,
      target: _propTypes["default"].string,
      name: _propTypes["default"].string
    }),
    link_url: _propTypes["default"].shape({
      url: _propTypes["default"].string,
      target: _propTypes["default"].string,
      name: _propTypes["default"].string
    })
  })).isRequired
};
var _default = ImageLinks;
exports["default"] = _default;